import FullScreenSpinner from 'src/components/FullScreenSpinner'
import ParticipantSessionBody from './ParticipantSessionBody'
import EmptyScreen from '../EmptyScreen'
import { useSignedUrl, useVirtualForeground, useAppSelector } from 'src/hooks'
import ParticipantSessionFooter from './ParticipantSessionFooter'
import { selectUserScreenName } from 'src/app/user'

function ParticipantSession() {
  const { isLoading, data } = useSignedUrl(1000)
  const showBadges = !!data?.name
  const participantScreenName = useAppSelector(selectUserScreenName)
  const myBadges = data?.participants?.[participantScreenName!]?.badges || []
  useVirtualForeground(showBadges, myBadges)

  return (
    <>
      {isLoading ? (
        <FullScreenSpinner />
      ) : (
        <>
          {showBadges ? (
            <ParticipantSessionBody {...data} />
          ) : (
            <div className="h-mainView overflow-scroll scrollbar-hide">
              <EmptyScreen>
                Badges will show here when the host shares a session
              </EmptyScreen>
            </div>
          )}
          <ParticipantSessionFooter />
        </>
      )}
    </>
  )
}

export default ParticipantSession
